module.exports = __webpack_public_path__ + "img/_cursor_grabbed.5de727b5.svg";